import React from "react";
import { TodoListView, TodoGridView } from "./components";
import type { ViewType } from "./types";

interface TodoPageProps {
  /** Which layout to show, driven by the matched route. */
  defaultView?: ViewType;
}

/**
 * Task feature entry point. Renders either the table (List) or the priority
 * accordions (Grid) based on the route. The in-toolbar toggle navigates between
 * the two task routes, so the active view always tracks the URL.
 */
const TodoPage: React.FC<TodoPageProps> = ({ defaultView = "list" }) => {
  return defaultView === "grid" ? (
    <TodoGridView view="grid" />
  ) : (
    <TodoListView view="list" />
  );
};

export default TodoPage;
